export const LICENCE_CATEGORY = 'licence-category';
export const OTHER_DETAILS = 'other-details';
export const FOREIGN_COMPANY_DETAILS = 'foreign-company-details';
export const STATION_EQUIPMENT_INFORMATION = 'station-equipment-information';
export const SUPPORTING_DOCUMENTS = 'supporting-documents';

export const TF_LICENCE = [
    {
        sectionID: LICENCE_CATEGORY,
        sectionName: '',
        fieldList: [
            {
                id: 'licence-category',
                label: 'Licence Category',
                type: 'text',
                span: 12
            }
        ]
    },
    {
        sectionID: OTHER_DETAILS,
        sectionName: 'Other Details',
        fieldList: [
            {
                id: 'proposed-used-of-system',
                label: 'Proposed use of System/Equipment',
                type: 'text'
            },
            {
                id: 'remarks',
                label: 'Remarks',
                type: 'text'
            }
        ]
    },
    {
        sectionID: FOREIGN_COMPANY_DETAILS,
        sectionName: 'Foreign Company Details',
        fieldList: [
            {
                id: 'foreign-company-name',
                label: 'Foreign Company Name',
                type: 'text'
            },
            {
                id: 'address-line-1',
                label: 'Address Line 1',
                type: 'text'
            },
            {
                id: 'address-line-2',
                label: 'Address Line 2',
                type: 'text'
            },
            {
                id: 'address-line-3',
                label: 'Address Line 3',
                type: 'text'
            },
            {
                id: 'address-line-4',
                label: 'Address Line 4',
                type: 'text'
            },
            {
                id: 'address-line-5',
                label: 'Address Line 5',
                type: 'text'
            },
            {
                id: 'email',
                label: 'Email',
                type: 'text'
            },
            {
                id: 'contact-number',
                label: 'Contact Number',
                type: 'text'
            },
            {
                id: 'city',
                label: 'City',
                type: 'text'
            },
            {
                id: 'state',
                label: 'State',
                type: 'text'
            },
            {
                id: 'zip-code',
                label: 'Zip Code',
                type: 'text'
            },
            {
                id: 'country',
                label: 'Country',
                type: 'text'
            }
        ]
    },
    {
        sectionID: STATION_EQUIPMENT_INFORMATION,
        sectionName: 'Station/Equipment Information',
        fieldList: [
            {
                id: 'station-equipment-name',
                label: 'Station/Equipment Name',
                type: 'text'
            },
            {
                id: 'purpose-and-objectives',
                label: 'Purpose and Objectives',
                type: 'text'
            }
        ]
    },
    {
        sectionID: SUPPORTING_DOCUMENTS,
        sectionName: 'Supporting Documents',
        fieldList: [
            {
                id: 'supporting-documents',
                label: ' ',
                type: 'file',
                span: 12
            }
        ]
    }
];
